import React, {memo} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {
  getActivityOrNotificationDescription,
  VERB_ICONS,
} from 'app/activity/shared-utils';
import ElapsedTime from 'app/components/general/ElapsedTime';

import type {ActivityType, TargetActionType} from 'app/activity/types/activity';
export const StyledItemContainerDiv = styled.div.attrs({
  className: 'clearfix pr-2 py-2 pl-5 small',
})`
  color: ${colors.textDefault};
  position: relative;

  .target-ct {
    display: none;
  }

  a.target {
    color: ${colors.textDefault};
  }

  .verb-icon {
    padding: 2px;
    color: #fff;
    background: ${colors.linkBlue};
    border-radius: 100%;
    position: absolute;
    left: 7px;

    .inner-circle {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 23px;
      height: 23px;
      padding: 3px;
      border-radius: 100%;
      background: #fff;
      color: ${colors.linkBlue};
    }
  }

  .description {
    .actors,
    .to_user {
      font-weight: bold;
    }

    .step {
      font-style: italic;
    }
  }
`;
type Props = {
  activity: ActivityType;
  contentArgs: TargetActionType;
};

const DetailPageActivitySidebarItem = ({activity, contentArgs}: Props) => {
  const {timestamp, verb} = activity;
  return (
    <StyledItemContainerDiv>
      <span className="verb-icon">
        <span className="inner-circle">
          <i className={`fa-fw ${VERB_ICONS[verb]}`} />
        </span>
      </span>
      <div className="description">
        {getActivityOrNotificationDescription(activity, contentArgs)}
      </div>
      <ElapsedTime
        tooltipPlacement="top"
        className="text-muted font-italic"
        timestamp={timestamp}
        small={true}
      />
    </StyledItemContainerDiv>
  );
};

export default memo<Props>(DetailPageActivitySidebarItem);
